const crumbClasses = "cursor-pointer bg-transparent border-0 p-0 text-subtle hover:text-content transition-colors";
const activeClasses = "font-bold text-content";
const plainClasses = "text-subtle";

const XCrumb = ({ item, isLast }) => {
    if (isLast) {
        return (
            <span className={activeClasses} aria-current="page">
                {item.label}
            </span>
        );
    }

    if (item.onClick) {
        return (
            <button type="button" className={crumbClasses} onClick={item.onClick}>
                {item.label}
            </button>
        );
    }

    return <span className={plainClasses}>{item.label}</span>;
};

export default XCrumb;
